import { groupBy } from 'lodash'
import { OrderConfigResponse } from '@ca/common'
import { OrderPriceSummary } from '@order/utils/summary/getOrderPriceSummary'
import { OrderItem } from '@order/orderTypes'
import { ItemBundle, ItemFrame } from './SummaryItem'
import { OrderState, ResolvedDealsContext } from '@order/hooks/state/orderState'

interface Props {
  summary: OrderPriceSummary | null
  result: OrderConfigResponse | null
  frames: OrderItem[]
  expanded?: boolean
  expandIds?: string[]
  order: OrderState
  deals: ResolvedDealsContext
}

export default function SummaryItems(props: Props) {
  const { summary, result, frames, expanded, expandIds, order, deals } = props

  const frameCount = {
    base: 0,
    extra: 0,
  }

  // const summary = useOrderSummary()
  // const result = useOrderState((s) => s.result)
  // const frames = useOrderState((s) => s.order.items)
  const framesByType = groupBy(frames, 'bundleType')

  return (
    <>
      {summary?.items.map(({ id, item, price, elements, values }, index) => {
        if (item.summary === 'bundle') {
          return (
            <ItemBundle
              key={item.id}
              values={values}
              id={id}
              item={item}
              price={price}
              elements={elements}
              borderBottom={index < summary.items.length - 1}
              expanded={expanded || expandIds?.includes(item.id)}
              deal={deals[item.bundleType]}
              order={order}
            />
          )
        }

        if (item.summary === 'frame') {
          frameCount[item.bundleType]++
          const res = result?.orders.find((r) => r.data.localId === item.id)

          return (
            <ItemFrame
              key={item.id}
              values={values}
              id={id}
              item={item}
              name={res?.name}
              price={price}
              deal={deals[item.bundleType]}
              order={order}
              borderBottom={index < summary.items.length - 1}
              elements={elements}
              totalCount={framesByType[item.bundleType].length}
              frameCount={frameCount[item.bundleType]}
              expanded={expanded || expandIds?.includes(item.id)}
            />
          )
        }
      })}
    </>
  )
}
